import { Moment } from 'moment';

export enum CPProgramWeekThreeStep {
    LivingAccordingToYourValuesStep = 'living-according-to-your-values',
    ChoosingValuedActionStep = 'choosing-a-valued-action',
    ActionAndCommitmentStep = 'action-and-commitment',
    ActionPracticeStep = 'action-practice',
    WeekThreePlanStep = 'follow-through-on-your-plan',
}

export interface LivingAccordingToValues {
    livingWithValuesFeelings: string;
    livingAgainstValuesFeelings: string;
}

export interface ActivitiesSelectionDomainBase {
    id: number;
    activities: ActivityData[];
}

export interface ActivitiesSelectionDomain extends ActivitiesSelectionDomainBase {
    title: string;
}

export interface ActivitiesSelectionRequestData extends ActivitiesSelectionDomainBase {
    name: string;
}

export interface ActivityDataBase {
    id: number;
    domainId: number;
    dateToBePerformed: Moment;
    additionalTitle: string;
    completed: boolean;
    checkInActionsAnswer: string;
}

export interface ActivityData extends ActivityDataBase {
    description: string;
    isChosen: boolean;
}

export interface PlannedActivity extends ActivityDataBase {
    domainTitle: string;
    title: string;
}

export interface ChangeActivitiesActionArguments {
    domainTitle: string;
    description: string;
}

export interface ChangeActivityDataActionArguments {
    domainTitle: string;
    description: string;
    field: string;
    value: string | Moment;
}

export interface ActivitiesDataArguments {
    domain: number;
    description: string;
    dateToBePerformed: Moment;
    isOther?: boolean;
    id: number;
}
